import { JOB } from '../../search/constants'

export const defaultIsUnsubscribed = false
export const defaultType = JOB

export default {
  username: null,
  code: null,
  isUnsubscribed: defaultIsUnsubscribed,
  headerImg: null,
  companyJobmailId: null,
  type: defaultType
}
